var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomeBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1249,
    height: 1323,
    viewBox: "0 0 1249 1323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0689 1069.04C31.8703 1132.23 84.56 1182 147.755 1180.2C319.702 1175.3 450.323 1140.49 550.515 1060C648.603 981.199 701.2 870.976 745.094 756.768C767.774 697.756 738.322 631.532 679.31 608.851C620.298 586.171 554.073 615.623 531.393 674.635C489.781 782.905 454.862 843.175 407.131 881.52C361.504 918.176 288.002 947.167 141.231 951.351C78.0363 953.152 28.2674 1005.84 30.0689 1069.04Z",
    fill: "url(#paint0_linear_112_1710)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.728 6.79781C549.245 28.2117 518.384 93.7917 539.798 153.275C598.063 315.124 671.859 428.382 779.575 498.486C885.029 567.117 1006.16 582.728 1128.36 588.828C1191.5 591.979 1245.24 543.348 1248.39 480.206C1251.54 417.065 1202.91 363.323 1139.77 360.171C1023.92 354.389 955.77 340.001 904.455 306.604C855.402 274.679 804.94 213.88 755.205 75.7282C733.791 16.2451 668.211 -14.6161 608.728 6.79781Z",
    fill: "url(#paint1_linear_112_1710)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_1710",
    x1: 582,
    y1: 698.999,
    x2: 348,
    y2: 1041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EF39D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_112_1710",
    x1: 825.073,
    y1: 273.152,
    x2: 1122.22,
    y2: 256.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EF39D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBackground);
export default __webpack_public_path__ + "static/media/WelcomeBackground.73c8af752c9f69c293228f1a252ddb96.svg";
export { ForwardRef as ReactComponent };